import { z } from "zod";

export const qlikVariableSchema = z.object({
  id: z.string(),
  name: z.string(),
  definition: z.string().optional(),
  description: z.string().optional(),
  isScriptCreated: z.boolean().optional(),
  isConfig: z.boolean().optional(),
  isReserved: z.boolean().optional(),
});

export type QlikVariable = z.infer<typeof qlikVariableSchema>;

export const listQlikVariablesResponseSchema = z.object({
  data: z.array(qlikVariableSchema),
});

export type ListQlikVariablesResponse = z.infer<typeof listQlikVariablesResponseSchema>;

export const updateQlikVariableInputSchema = z.object({
  name: z.string().min(1).optional(),
  definition: z.string().optional(),
  description: z.string().optional(),
});

export type UpdateQlikVariableInput = z.infer<typeof updateQlikVariableInputSchema>;
